import { userPermission, userType } from "@/helpers/enums";
import { getPermissions } from "../TEMP_PERMISSIONS_WILL_GET_THEM_FROM_API"
import * as types from './mutation-types.js'
const state = () => ({
    permissions: {
        bond: {
            properties: {},
            actions: {
                create: true,
                edit: true,
                delete: true,
                get: true
            }
        },
        entry:{
            properties: {},
            actions: {
                create: true,
                edit: true,
                delete: true,
                get: true
            }
        },
        account: {
            properties: {},
            actions: {
                create: true,
                edit: true,
                delete: true,
                get: true
            }
        },
        daily_table: {
            properties: {},
            actions: {
                create: true,
                edit: true,
                delete: true,
                get: true,
                export_as_pdf: true
            }
        },
        statement: {
            properties: {},
            actions: {
                create: true,
                edit: true,
                delete: true,
                get: true,
                export_as_pdf: true
            }
        },
        custom_statement: {
            properties: {},
            actions: {
                create: true,
                edit: true,
                delete: true,
                get: true,
                export_as_pdf: true,
            }
        },
        trial_balance: {
            properties: {},
            actions: {
                create: true,
                edit: true,
                delete: true,
                get: true,
                export_as_pdf: true
            }
        },
        final_account: {
            properties: {},
            actions: {
                create: true,
                edit: true,
                delete: true,
                get: true,
                export_as_pdf: true
            }
        },
        currency: {
            properties: {},
            actions: {
                create: true,
                edit: true,
                delete: true,
                get: true
            }
        },
        financial_file: {
            properties: {},
            actions: {
                create: true,
                edit: true,
                delete: true,
                get: true
            }
        },
        user: {
            properties: {},
            actions: {
                create: true,
                edit: true,
                delete: true,
                get: true
            }
        },
        user_preferences: {
            properties: {},
            actions: {
                create: true,
                edit: true,
                delete: true,
                get: true
            }
        },
        warehouse: {
            properties: {},
            actions: {
                create: true,
                edit: true,
                delete: true,
                get: true
            }
        },
        invoice: {
            properties: {},
            actions: {
                create: true,
                edit: true,
                delete: true,
                get: true
            }
        },
        statistics: {
            properties: {},
            actions: {
                create: true,
                edit: true,
                delete: true,
                get: true
            }
        },
        matching_table:{
            properties: {},
            actions: {
                create: true,
                edit: true,
                delete: true,
                get: true
            }
        },
        unit_size:{
            properties: {},
            actions: {
                create: true,
                edit: true,
                delete: true,
                get: true
            }
        },
        material:{
            properties: {},
            actions: {
                create: true,
                edit: true,
                delete: true,
                get: true
            }
        },
        inventory:{
            properties: {},
            actions: {
                create: true,
                edit: true,
                delete: true,
                get: true,
                export_as_pdf: true
            }
        },
        materials_journal:{
            properties: {},
            actions: {
                create: true,
                edit: true,
                delete: true,
                get: true
            }
        },
        manifest:{
            properties: {},
            actions: {
                get: true
            }
        },
        tree:{
            properties: {},
            actions: {
                export_as_pdf: true
            }
        },
        permissionsUserForFinancialFile: []
    },
    user_type: null
});

const actions = {
    fetchPermissionType({ commit }, { user_id, financial_file_id }) {
        return axios.get(`Users/${user_id}/${financial_file_id}/Permissions`).then(response => {
            let type;
            let roleType = response.data.role_type;

            if ([userPermission.accountant, userPermission.advanceAccountant].includes(roleType)) {
                type = userType.accountant;
            } else if (roleType === userPermission.viewer) {
                type = userType.viewer;
            } else if ([userPermission.warehouseKeeper, userPermission.warehouseManger].includes(roleType)) {
                type = roleType;
            } else {
                type = null;
            }
            
            const data = {
                can_create_financial_file:
                    !response.data || roleType === userPermission.advanceAccountant,
                //new work
                permission_type: type
                // pervious work
                // permission_type: 
                //     [userPermission.accountant, userPermission.advanceAccountant]
                //         .includes(roleType)
                //         ? userType.accountant
                //         : roleType === userPermission.viewer ? userType.viewer : null

                // my work
                // permission_type: 
                //     [userPermission.warehouseKeeper, userPermission.warehouseManager]
                //          .includes(roleType)
                //          ? userType.accountant
                //          : roleType === userPermission.viewer ? userType.viewer : null
            }
            
            if (response.data == null || roleType === userPermission.accountant) {
                commit(types.STORE_USER_TYPE, 1);
            } else {
                commit(types.STORE_USER_TYPE, data.permission_type);
            }
            commit(types.STORE_PERMISSION_USER_FOR_FINANCIAL_FILE, data)
            return data
        })
    },
};

const mutations = {
    [types.STORE_USER_TYPE](state, user_type) {
        state.user_type = user_type;
        state.permissions = getPermissions(user_type);
    },

    [types.STORE_PERMISSION_USER_FOR_FINANCIAL_FILE](state, permissionsUserForFinancialFile) {
        state.permissionsUserForFinancialFile = permissionsUserForFinancialFile
    }
};

export default {
    namespaced: true,
    state,
    actions,
    mutations
};